import DetailsProduct from "./DetailsProduct";

export default DetailsProduct;
